export default class PublicTransportViewModel {
    publicTransportConnectivityScore: number | null = null;
    // --< Public transport 1 - 10 >--
    weekdayBusAllDay: number | null = null;
    weekdayBusAM: number | null = null;
    weekdayBusPM: number | null = null;
    saturdayBus: number | null = null;
    sundayBus: number | null = null;

    weekdayTrainAllDay: number | null = null;
    weekdayTrainAM: number | null = null;
    weekdayTrainPM: number | null = null;
    saturdayTrain: number | null = null;
    sundayTrain: number | null = null;

    weekdayTotalAllDay: number | null = null;
    weekdayTotalAM: number | null = null;
    weekdayTotalPM: number | null = null;
    saturdayTotal: number | null = null;
    sundayTotal: number | null = null;

    reasonForBlankPT: string | null = null;

    // Bus 1 - 5
    isSiteSpecificBusService?: boolean | null = null;
    numberOfYearsBusService?: string | null = '';
    isBusStopNearSite?: boolean | null = null;
    isCrossRoad?: boolean | null = null;
    isTwoOrMoreBusServices?: boolean | null = null;
    busServiceCharacteristics?: string | null = '';

    // Bus 6
    busDestinationTown1: string | null = null;
    busDestinationTown2: string | null = null;
    busDestinationTown3: string | null = null;
    busDestinationTown4: string | null = null;

    busFrequency1: string | null = null;
    busFrequency2: string | null = null;
    busFrequency3: string | null = null;
    busFrequency4: string | null = null;

    busJourneyTime1: string | null = null;
    busJourneyTime2: string | null = null;
    busJourneyTime3: string | null = null;
    busJourneyTime4: string | null = null;

    // Rail 7 - 10
    isStationNearSite?: boolean | null = null;
    isPedestrianAccessToStation?: boolean | null = null;
    isTwoOrMoreTrainServices?: boolean | null = null;
    railServiceCharacteristsics?: string | null = '';

    trainDestinationTown1: string | null = null;
    trainDestinationTown2: string | null = null;
    trainDestinationTown3: string | null = null;
    trainDestinationTown4: string | null = null;
    trainFrequency1: string | null = null;
    trainFrequency2: string | null = null;
    trainFrequency3: string | null = null;
    trainFrequency4: string | null = null;
    trainJourneyTime1: string | null = null;
    trainJourneyTime2: string | null = null;
    trainJourneyTime3: string | null = null;
    trainJourneyTime4: string | null = null;

    // General Comments 11
    generalComments?: string | null = '';
}
